import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener, Input, NgZone } from '@angular/core';
import { finalize, delay } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { untilDestroyed } from 'src/app/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AnalyticsService } from './analytics.service';
import { Main } from 'src/app/core/main.service';
import * as FusionCharts from 'fusioncharts';

@Component({
  selector: 'app-ekubs-analytics',
  templateUrl: './ekubs.analytics.component.html',
  styleUrls: ['./ekubs.analytics.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EkubsAnalyticsComponent implements OnInit, OnDestroy {
  title: string;
  filter: string;
  dataSource: any;
  pieDataSource: any;
  analyticsDTO: any = {
    total_ekubs: 0,
    total_members: 0,
    total_active_members: 0,
    total_disqualified_members: 0,
    lagging_percentage: 0,
    disqualified_members: 0,
    total_balance: 0,
    balance_due: 0,
    balance_percentage: 0,
    total_sales: {
      count: 0,
      value: 0
    },
    pending_sales: {
      count: 0,
      value: 0
    },
    awards_granted: {
      count: 0,
      value: 0
    },
    awards_pending: {
      count: 0,
      value: 0
    },
    ekubs: [],
    lagging: []
  };
  chartConfig: Object;
  dataSource2: any;
  chartConfig2: Object;

  laggingEkubs: any = [
    {
      ekubID: 'EK-124123',
      draw_date: 'Jan 10, 2021',
      status: 'active',
      amountLagged: 120000,
    }, {
      ekubID: 'EK-244123',
      draw_date: 'Jan 10, 2021',
      status: 450000
    },
    {
      ekubID: 'EK-454123',
      draw_date: 'Jan 10, 2021',
      status: 510000
    }
  ];


  constructor(private router: Router, private route: ActivatedRoute,
    private api: AnalyticsService, private mainService: Main) {
    this.filter = '';
    this.chartConfig2 = {
      /*   width: '700',
        height: '400', */
      width: '100%',
      height: '585',
      type: 'column2d',
      dataFormat: 'json',
      palettecolors: "FFE4B5",
      chartLeftMargin: "40",
      chartTopMargin: "40",
      chartRightMargin: "40",
      chartBottomMargin: "40",
      canvasPadding: "30",
      canvasLeftPadding: "40",
      canvasRightPadding: "40",
      canvasTopPadding: "40",
      canvasBottomPadding: "40",
      labelFontColor: "0075c2",
    };

    this.dataSource2 = {
      "chart": {
        "caption": "Transactions Statistics ",
        "subCaption": "past 12 months - the higher the better",
        "xAxisName": "Month",
        "yAxisName": "Transactions (in ETB)",
        //"numberSuffix": "K",
        "theme": "fusion",
        "palettecolors": "#CCA696",
        //"labelFontColor": "#0075c2",
      },
      data: []
    };


    this.pieDataSource = {
      chart: {
        "caption": "Ekubs Health",
        //"plottooltext": "<b>$percentValue</b> of ekubs $label servers",
        "showLegend": "1",
        "showPercentValues": "1",
        "legendPosition": "bottom",
        "useDataPlotColorForLabels": "1",
        "enablemultislicing": "0",
        "showlegend": "0",
        "theme": "fusion",
        "labelFontColor": "#0075c2",
        "canvasPadding": "0",
        "chartLeftMargin": "-70",
        width: '100%',
        height: '585',
      },
      data: []
    };

    this.chartConfig = {
      type: 'doughnut2d',
      width: '550',
      height: '400',
      //palettecolors: "FFE4B5",
    };
    this.dataSource = {
      // Initially data is set as null
      chart: {
        showLegend: 1,
      },
      data: null,
      caption: {
        text: ''
      },
      subcaption: {
        text: 'since 2015'
      },
      yAxis: [
        {
          plot: [
            {
              value: 'Total Users',
              type: 'column'
            },
            {
              value: 'Active Users',
              type: 'line'
            }
          ]
        }
      ]
    };
    this.getAnalyticsFilter('');
  }

  ngOnInit() {

  }

  getAnalyticsFilter(filter: any) {
    this.filter = filter;
    this.getAnanlytics();
  }

  getBalancePercentage() {
    return this.analyticsDTO?.balance_percentage + '%';
  }
  getLaggingPercentage() {
    return this.analyticsDTO?.lagging_percentage + '%';
  }

  getAnanlytics() {
    debugger;
    this.api.getAnalytics('')
      .subscribe((res: any) => {
        debugger;
        //this.isLoading = !this.isLoading;
        this.analyticsDTO = res.data;
        this.pieDataSource.data.push({
          "label": "Total Balance",
          "value": this.analyticsDTO.total_balance,
          "color": "#00A300"
        });
        this.pieDataSource.data.push({
          "label": "Balance Due",
          //"value": this.analyticsDTO.balance_due,
          "value": this.analyticsDTO.difference,
          "color": "#DC143C"
        });
        for (let transaction of this.analyticsDTO.transactions) {
          this.dataSource2.data.push({
            "label": transaction.month,
            "value": transaction.total_transactions_value,
            //"color": "#DC143C"
          });
        }
        this.dataSource2.data.push({
          "data": [{
            "label": "Jan",
            "value": "290"
          }, {
            "label": "Feb",
            "value": "260"
          }, {
            "label": "Mar",
            "value": "180"
          }, {
            "label": "Apr",
            "value": "140"
          }, {
            "label": "May",
            "value": "115"
          }, {
            "label": "June",
            "value": "100"
          }, {
            "label": "July",
            "value": "30"
          }, {
            "label": "Aug",
            "value": "30"
          }, {
            "label": "Sep",
            "value": "30"
          }, {
            "label": "Oct",
            "value": "30"
          }, {
            "label": "Nov",
            "value": "30"
          }, {
            "label": "Dec",
            "value": "30"
          }]
        });
      }, (err) => {
        debugger;
        err = err;
        //this.isLoading = !this.isLoading;
        this.mainService.toast({ title: 'Error', body: 'Error fetching dashboard stats!', type: 'danger' });
      });
  }

  getEkubFilter(filter: any) {
    this.filter = filter;
    this.getAnanlytics();
  }

  ngOnDestroy(): void {

  }

}
